/*global app, me*/
"use strict";

var HumanModel = require('human-model');

module.exports = HumanModel.define({
    type: 'contactRequest',
    props: {
        jid: ['string', true, '']
    }
});


//////////////////
// WEBPACK FOOTER
// ./models/contactRequest.js
// module id = 797
// module chunks = 2